import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DebouncedInput from 'Common/Components/v2/DebouncedInput';
import { setBulkUpdateValue } from 'store/Manage/actions';
import { selectModalBulkUpdateValue } from 'store/Manage/selectors';

const ExternalIdInput = () => {
  const dispatch = useDispatch();
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);

  const onChange = (value) => dispatch(setBulkUpdateValue(value));

  return (
    <DebouncedInput
      value={ bulkUpdateValue }
      onChange={ onChange }
      name="external_id"
      title="external ID"
      focusOnMount
      immediate
    />
  );
};

export default ExternalIdInput;
